export default "__VITE_ASSET__BCU4gtVm__"